class BannerCarouselFunctionality {
  constructor(sectionId, interval = null) {
    this.sectionId = sectionId;
    this.track = document.querySelector(`.slideshow--${sectionId}`);
    this.slides = document.querySelectorAll(`.banner-slides--${sectionId}`);
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.dragOffset = 0;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onPointerCancel = this.onPointerCancel.bind(this);

    this.initEvents();
    if (interval) this.autoScroll(interval);
  }

  get slideCount() {
    return this.slides.length;
  }

  changeSlide(targetIndex) {
    this.goTo(targetIndex);
  }

  goTo(index) {
    this.currentIndex = Math.max(0, Math.min(index, this.slideCount - 1));
    this.applyTransform(true);
    this.changeActiveControl(this.currentIndex);
  }

  applyTransform(animated) {
    this.track.style.transition = animated ? 'transform 0.4s ease' : 'none';
    this.track.style.transform = `translateX(calc(${-this.currentIndex * 100}% + ${this.dragOffset}px))`;
  }

  onPointerDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    this.isPointerDown = true;
    this.wasDragged = false;
    this.pressedTarget = e.target;
    this.startX = e.clientX;
    this.dragOffset = 0;
    this.track.setPointerCapture(e.pointerId);
    this.applyTransform(false);
    this.track.style.cursor = 'grabbing';
  }

  onPointerMove(e) {
    if (!this.isPointerDown) return;
    this.dragOffset = e.clientX - this.startX;
    if (Math.abs(this.dragOffset) > 8) this.wasDragged = true;
    this.applyTransform(false);
  }

  onPointerUp() {
    if (!this.isPointerDown) return;
    this.isPointerDown = false;
    this.track.style.cursor = 'grab';

    if (!this.wasDragged) {
      this.dragOffset = 0;
      const activeSlide = this.slides[this.currentIndex];
      const button = activeSlide && activeSlide.querySelector('button');
      if (button) button.click();
      return;
    }

    const threshold = this.track.clientWidth * 0.2;

    if (this.dragOffset < -threshold && this.currentIndex < this.slideCount - 1) {
      this.currentIndex++;
    } else if (this.dragOffset > threshold && this.currentIndex > 0) {
      this.currentIndex--;
    }

    this.dragOffset = 0;
    this.applyTransform(true);
    this.changeActiveControl(this.currentIndex);
  }

  onPointerCancel() {
    if (!this.isPointerDown) return;
    this.isPointerDown = false;
    this.wasDragged = false;
    this.track.style.cursor = 'grab';
    this.dragOffset = 0;
    this.applyTransform(true);
  }

  autoScroll(interval) {
    setInterval(() => {
      const next = (this.currentIndex + 1) % this.slideCount;
      this.goTo(next);
    }, interval);
  }

  changeActiveControl(index) {
    const prev = document.querySelector(`.banner-arrow--prev--${this.sectionId}`);
    const next = document.querySelector(`.banner-arrow--next--${this.sectionId}`);
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === this.slideCount - 1;
  }

  initEvents() {
    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerUp);
    this.track.addEventListener('pointercancel', this.onPointerCancel);
    this.track.addEventListener('dragstart', (e) => e.preventDefault());
    this.track.style.cursor = 'grab';
    this.track.style.touchAction = 'pan-y';
  }
}